import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { usePostMasterMupload } from '../../../../api/masters/masters';
import { useDefaultOptions } from '../../../../hooks/api';
import ErrorModal from '../../../modules/ErrorModal';

interface Props {
  masterVersionId: number;
  isMaster: number;
  setImagePath: (imagePath: string) => void;
  setExcelPath: (excelPath: string) => void;
  setBtnEnabled: (btnEnabled: boolean) => void;
}
function MasterUpload({ masterVersionId, isMaster, setImagePath, setExcelPath, setBtnEnabled }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const options = useDefaultOptions(language);
  const { mutateAsync, isError, error } = usePostMasterMupload(options);
  const [filename, setFilename] = useState<string | null>(null);
  const [displayErrorModal, setDisplayErrorModal] = useState(false);

  const onDrop = async (acceptedFiles: File[]) => {
    // API 実行
    const response = await mutateAsync({
      masterVersionId,
      data: { file: acceptedFiles[0] },
    });

    if (isMaster === 1) {
      if (response.data != null && response.data.image_temp_path && response.data.excel_temp_path) {
        setFilename(acceptedFiles[0].name);
        setImagePath(response.data.image_temp_path);
        setExcelPath(response.data.excel_temp_path);
      }
    } else if (response.data != null && response.data.excel_temp_path) {
      setFilename(acceptedFiles[0].name);
      setExcelPath(response.data.excel_temp_path);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  useEffect(() => {
    setBtnEnabled(!isError);
    if (isError && error?.response?.data.message) {
      setDisplayErrorModal(true);
    }
  }, [isError, error, setBtnEnabled]);

  return (
    <div id="upFileWrap" {...getRootProps()}>
      <div id="inputFile">
        <span id="dropAreaBefore">{t('ファイルをドロップ　または　')}</span>
        <label id="dropArea" htmlFor="uploadFile">
          <i className="fa-solid fa-arrow-up-from-bracket" />
          <input type="file" id="fg_img" name="fg_img" {...getInputProps()} />
          <span className="fileselecttxt">{t('ファイルを選択')}</span>
          <span className="selectfile" id="prevFile_name">
            {filename}
          </span>
        </label>
      </div>
      {displayErrorModal && <ErrorModal error={error} onClickOk={() => setDisplayErrorModal(false)} />}
    </div>
  );
}

export { MasterUpload };
